import $ from 'jquery';

export default function newsLoader() {
  const $grid = $('#news-grid');
  const $btn = $('#load-more-news-btn');
  const $spinner = $('#news-results .loading-alt');
  const $pagination = $('#news-pagination');

  if (!$grid.length || !$btn.length || !$pagination.length) return;

  const perPage = parseInt($pagination.data('offset'), 10) || 9;
  const postType = $pagination.data('post-type') || 'post';
  let loadedCount = perPage;

  /**
   * Get search + filter values
   */
  function getFilterValues() {
    const search = $('#search-input').val() || '';
    const articleType = $('#filter-select').val() || '';
    return { search, articleType };
  }

  /**
   * Spinner control
   */
  function showSpinner() {
    $spinner.fadeIn(200);
  }
  function hideSpinner() {
    $spinner.fadeOut(200);
  }

  /**
   * Fade out current grid before load
   */
  function fadeOutGrid(callback) {
    $grid.animate({ opacity: 0 }, 200, 'swing', callback);
  }

  /**
   * Fade in grid after new content
   */
  function fadeInGrid() {
    $grid.animate({ opacity: 1 }, 200, 'swing');
  }

  /**
   * Load articles via AJAX
   */
  function loadArticles(search = '', articleType = '', append = false) {
    $btn.prop('disabled', true).text('Loading...');

    // 1️⃣ Fade out existing cards first
    fadeOutGrid(() => {
      // 2️⃣ Then show spinner
      showSpinner();

      $.ajax({
        url: window.wpData?.ajaxUrl || '/wp-admin/admin-ajax.php',
        type: 'POST',
        dataType: 'json',
        data: {
          action: 'filter_articles',
          post_type: postType,
          s: search,
          offset: append ? loadedCount : 0,
          per_page: perPage,
          gatc_article_types: articleType,
        },
        success(res) {
          // 3️⃣ Hide spinner once results arrive
          hideSpinner();

          if (res.success && res.data.html) {
            if (append) {
              $grid.append(res.data.html);
              loadedCount += perPage;
            } else {
              $grid.html(res.data.html);
              loadedCount = perPage;
            }

            // 4️⃣ Fade cards back in
            fadeInGrid();

            if (res.data.has_more) {
              $btn.prop('disabled', false).text('See more').show();
            } else {
              $btn.hide();
            }

            if (window.AOS) AOS.refresh();
          } else {
            $grid.html('<p class="text-center">No results found.</p>');
            fadeInGrid();
            $btn.hide();
          }
        },
        error() {
          hideSpinner();
          $btn.prop('disabled', false).text('See more');
          console.error('AJAX failed while loading articles.');
          fadeInGrid();
        },
      });
    });
  }

  /**
   * Search input (Enter)
   */
  $('#search-input').on('keypress', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      const { search, articleType } = getFilterValues();
      loadArticles(search, articleType, false);
    }
  });

  /**
   * Filter dropdown (Change)
   */
  $('#filter-select').on('change', function () {
    const { search, articleType } = getFilterValues();
    loadArticles(search, articleType, false);
  });

  /**
   * Load More button
   */
  $btn.on('click', function (e) {
    e.preventDefault();
    const { search, articleType } = getFilterValues();
    loadArticles(search, articleType, true);
  });
}
